import styles from "./reply-dialog.module.scss";
import { replyContext } from "@components/chat";
import { useContext } from "react";
import { ReactComponent as ExitIcon } from "@assets/svg/exit.svg";
import { animated, useTransition } from "react-spring";

export default function ReplyDialog(): JSX.Element {
  const { reply, resetReply } = useContext(replyContext);
  const replyTransition = useTransition(reply.message !== "", {
    from: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
    },
  });
  return (
    <>
      {replyTransition(
        (style, item) =>
          item && (
            <animated.div className={styles.reply} style={style}>
              <img src={reply.user.avatar_url} />
              <span>
                <b>@{reply.user.username}: </b>
                {reply.message}
              </span>
              <ExitIcon onClick={resetReply} />
            </animated.div>
          )
      )}
    </>
  );
}
